export default __webpack_public_path__ + "static/media/phone.cbcb5c99.svg";